import path from '@/api/index'
import {
    axios
} from '@/utils/request'

const prefix = '/my/bill'
// 分页
export function getBill () {
    return axios({
        url: path.client + prefix + '/getBill',
        method: 'get'
    })
}
